import { createRouter, createWebHistory } from 'vue-router';

import Login from '../views/Login.vue';
import Setting from '../views/Setting.vue';
import RewardsRedeem from '../views/Rewards/Redeem.vue';

const routes = [
    { path: '/login', name: 'login', component: Login },
    { path: '/setting', name: 'setting', component: Setting },
    { path: '/rewards/redeem', name: 'rewards-redeem', component: RewardsRedeem },
    // { path: '*', redirect: '/rewards/redeem' }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
